module.exports = function(posts) {
	'use strict'
	posts.directive('editImageModal',editImageModal);
	editImageModal.$inject=["postDataService","putDataService",'getDataService','$rootScope','activeClass','refreshtokenService','cleanObj','alertService','serverError','offlineError'];
	function editImageModal(postDataService,putDataService,getDataService,$rootScope,activeClass,refreshtokenService,cleanObj, alertService,serverError,offlineError) {
		return {
			restrict: 'E',
			scope: {
				currentPostObj:"="
			},
			template: require('./partial/edit-image.html'),
			link: function(scope, ele, $attrs, ctrl) {
				scope.activeClassAlign = {
					alignleft : false,
					aligncenter : false,
					alignright : false,
					alignnone : false,
				}
				scope.selectedLink = {value:'none'};
				scope.customUrlShow = false;
				scope.editImageObj = {};
				scope.editImageObj.link_to = 'https://';
				scope.editImageObj.target_blank = false;
				scope.changeLink = function(link) {
					if(link=='url') {
						if(!scope.editImageObj.link_to) {
							scope.editImageObj.link_to = 'https://'
						}
						scope.customUrlShow = true;
					} else {
						scope.editImageObj.link_to = 'https://'
						scope.customUrlShow = false;
					}
				}
				scope.changeAlignStatus = function(event, align_status) {
					activeClass.active(event);
					scope.editImageObj.align = align_status;
				}
				
				scope.updateImage = function() {
					if(!scope.editImageObj.signature) {
						alertService('danger','Opps! ', 'Image does not have caption');
						return
					}
					if (scope.editImageObj.link_to == 'https://') {
						scope.editImageObj.link_to = null;
						scope.editImageObj.target_blank = null;
					};
					cleanObj.clean(scope.editImageObj);
					scope.currentPostObj.editImagefromEditor = false;
					$rootScope.modalShow = false;
					scope.$parent.$parent.$broadcast('update-image-editor', {updateImageObject:scope.editImageObj}); 
				}
				var deleteFunction = function () {
					putDataService.update({
						param1: 'attachments',
						param2: 'bulk',
						param3: 'delete'
					}, {
							'delete_ids': scope.mediaIds,
						}).$promise.then(function (bulkDelete) {
							scope.currentPostObj.editImagefromEditor = false;
							$rootScope.modalShow = false;
							$rootScope.hasLoaded = true;
							alertService('success', 'SUCCESS ', bulkDelete.message, 2000);
							scope.$parent.$parent.$broadcast('delete-media', {updateImageObject:scope.editImageObj});

						}, function (error) {
							if(!window.navigator.onLine) {
								offlineError()
								$rootScope.hasLoaded = true;
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
							if (error.status == 401) {
								var promise = refreshtokenService.getAccessToken();
								promise.then(
									function (answer) {
										if (answer == 200) {
											putFunction();
										}
									},
									function (error) {
										// report something
									},
									function (progress) {
										// report progress
									});
							} else if (error.status == 502) {
								serverError();
							} else {
								alertService('danger', 'Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							}
							$rootScope.hasLoaded = true;
						});
				}
				scope.deleteMedia = function (id) {
					$rootScope.hasLoaded = false;
					scope.mediaIds = [id];
					deleteFunction();
				}
				function changeMediaStatus(postIds, param) {
					if(!postIds) return;
					$rootScope.hasLoaded = false;
					postDataService.save({
						param1:'attachments',
						param2:'status',
						param3:param
					},{
						'ids': postIds,
					}).$promise.then(function(data){
						$rootScope.hasLoaded = true;
						getAttachmentsFunction()
						alertService('success','Success ', data.message, 2000);
					}, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							$rootScope.hasLoaded = true;
							alertService('danger','Opps! ', 'Please check your internet connection and try again.');
							return
						}
						if(error.status ==401) {
							var promise = refreshtokenService.getAccessToken();
							promise.then(
								function(answer) {
								if(answer==200) {
									changeMediaStatus(postIds, param);
								}
								},
								function(error) {
								// report something
								},
								function(progress) {
								// report progress
							});
						} else if(error.status ==502) {
						serverError()
						} else {
						console.log(error)
						alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
						}
						$rootScope.hasLoaded = true;
					});
				}
				scope.changeMediaStatus = function(postId,param) {
					changeMediaStatus([postId], param)
				}
				var getAttachmentsFunction = function() {
					getDataService.get({
			            param1: 'attachments',
			            param2: scope.currentPostObj.editImageObj.id,  
		            }).$promise.then(function(data){
		            	scope.editImageObj = data;
						scope.editImageObj.file = data.file;
						scope.editImageObj._id = scope.currentPostObj.editImageObj.id;
						if(scope.currentPostObj.editImageObj.signature_image) {
							scope.editImageObj.signature = scope.currentPostObj.editImageObj.signature_image;
						} else if(scope.currentPostObj.editImageObj.signature_image == null || scope.currentPostObj.editImageObj.signature_image == undefined) {
							scope.editImageObj.signature = data.signature;
						}
						if(scope.currentPostObj.editImageObj.align) {
							scope.activeClassAlign[scope.currentPostObj.editImageObj.align] = true;
							scope.editImageObj.align = scope.currentPostObj.editImageObj.align;
						}
						if (scope.currentPostObj.editImageObj.href) {
							scope.customUrlShow = true;
							scope.selectedLink = {value:'url'};
							scope.editImageObj.link_to = scope.currentPostObj.editImageObj.href;
						}
						if(scope.currentPostObj.editImageObj.target_blank) {
							scope.editImageObj.target_blank = true;
						} 
		          	}, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							return
						}
						if(error.status ==401) {
							var promise = refreshtokenService.getAccessToken();
							promise.then(
								function(answer) {
								if(answer==200) {   
									getAttachmentsFunction();
								}
								},
								function(error) {
								},
								function(progress) {
								// report progress
							});
						} else if(error.status ==502) {
							serverError()
						} else {
						alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
						}  
			      	});	
				}
				getAttachmentsFunction();
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/edit-newpost/js/directive/editImageDirective.js
// module id = 557
// module chunks = 0